/**
 * @generated SignedSource<<09aa024813df44346c2e209ce786b3ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CompleteSetupInput = {
  countryId: number;
  userProfileType: string;
  accountName: string;
  addressLineOne: string;
  addressLineTwo: string;
  city: string;
  state: string;
  zip: string;
  timeZone: string;
  lat: number;
  lng: number;
  addressComponents: string;
  accreditationBody?: string | null;
  accreditationMemberNumber?: string | null;
};
export type authCompleteSetupMutation$variables = {
  input: CompleteSetupInput;
};
export type authCompleteSetupMutation$data = {
  readonly completeSetup: boolean;
};
export type authCompleteSetupMutation = {
  variables: authCompleteSetupMutation$variables;
  response: authCompleteSetupMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "completeSetup",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "authCompleteSetupMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "authCompleteSetupMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d6eeaf9943590b3fca78dc528959293c",
    "id": null,
    "metadata": {},
    "name": "authCompleteSetupMutation",
    "operationKind": "mutation",
    "text": "mutation authCompleteSetupMutation(\n  $input: CompleteSetupInput!\n) {\n  completeSetup(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "df7cac625a24bae1ee7f5191a05830a1";

export default node;
